export const addProduct = (product) => {
    return {
        type: 'ADD_PRODUCT',
        payload: product,
    };
};

export const removeProduct = (index) => {
    return {
        type: 'REMOVE_PRODUCT',
        payload: index,
    };
};

export const removeAll = () => {
    return {
        type: 'REMOVE_ALL_PRODUCTS',
    };
};
